
/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// require('../../../node_modules/jquery/dist/jquery.js');


// window.autosize = require('../../../node_modules/autosize/dist/autosize.js');
window.autosize = require('autosize');
require('./autosize-init.js');

require('./counter.js');

//Application Custom JS
require('./user-notifications.js');
require ('./ripple-effect.js');

//=============TinyMCE======================
// Core TinyMCE - these two are required :-)
// import tinymce from 'tinymce';

import 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';

// Plugins TinyMCE
import '../../../../../node_modules/tinymce/plugins/autoresize/plugin';
import '../../../../../node_modules/tinymce/plugins/advlist/plugin';
import '../../../../../node_modules/tinymce/plugins/autolink/plugin';
import '../../../../../node_modules/tinymce/plugins/lists/plugin';
import '../../../../../node_modules/tinymce/plugins/link/plugin';
import '../../../../../node_modules/tinymce/plugins/image/plugin';
import '../../../../../node_modules/tinymce/plugins/charmap/plugin';
import '../../../../../node_modules/tinymce/plugins/print/plugin';
import '../../../../../node_modules/tinymce/plugins/preview/plugin';
import '../../../../../node_modules/tinymce/plugins/hr/plugin';
import '../../../../../node_modules/tinymce/plugins/anchor/plugin';
import '../../../../../node_modules/tinymce/plugins/pagebreak/plugin';
import '../../../../../node_modules/tinymce/plugins/searchreplace/plugin';
import '../../../../../node_modules/tinymce/plugins/wordcount/plugin';
import '../../../../../node_modules/tinymce/plugins/visualblocks/plugin';
import '../../../../../node_modules/tinymce/plugins/visualchars/plugin';
import '../../../../../node_modules/tinymce/plugins/code/plugin';
import '../../../../../node_modules/tinymce/plugins/fullscreen/plugin';
import '../../../../../node_modules/tinymce/plugins/insertdatetime/plugin';
import '../../../../../node_modules/tinymce/plugins/media/plugin';
import '../../../../../node_modules/tinymce/plugins/nonbreaking/plugin';
import '../../../../../node_modules/tinymce/plugins/save/plugin';
import '../../../../../node_modules/tinymce/plugins/table/plugin';
import '../../../../../node_modules/tinymce/plugins/contextmenu/plugin';
import '../../../../../node_modules/tinymce/plugins/directionality/plugin';
import '../../../../../node_modules/tinymce/plugins/emoticons/plugin';
import '../../../../../node_modules/tinymce/plugins/template/plugin';
import '../../../../../node_modules/tinymce/plugins/paste/plugin';
import '../../../../../node_modules/tinymce/plugins/textcolor/plugin';
import '../../../../../node_modules/tinymce/plugins/colorpicker/plugin';
import '../../../../../node_modules/tinymce/plugins/textpattern/plugin';
import '../../../../../node_modules/tinymce/skins/lightgray/skin.min.css';

require('./tinymce-init.js');
//=============End TinyMCE======================

//Bootstrap  Notify
// require('../../../../node_modules/bootstrap-notify/bootstrap-notify.js');
require('bootstrap-notify/bootstrap-notify.js');
require('./bootstrap-notify-init.js');
require('./bootstrap-tooltip-init.js');

require('bootstrap-toggle/js/bootstrap-toggle');
require('./bootstrap-multiple-target-tabs.js');


//Fix menu
require('./fix-menu.js');

//Count Score in user menu
require('./score-count.js');

//Disable more than one submit
require('./disable_multy_submit.js');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

// var draggable = require('vuedraggable');

//Vue.component('example', require('./components/Example.vue'));


require('./loader.js');

//Upload Image Preview
require( './file-upload-single.js');


//Confirm Leave form
require('./confirm-leqaving-form.js');

//Cookie Consent
import { CookieConsent } from 'cookieconsent';


//Smart Menu
// require('./smartmenus.js');
// require('./smartmenus-bootstrap.js');
// require('./smartmenus-init.js');





// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/app.js